import ExamList from './ExamList';

const ACTION = {
  ...ExamList.ACTION,
};

const ACTION_TYPES = {
  ...ExamList.ACTION_TYPES,
};

const Exam = {
  ACTION,
  ACTION_TYPES
}

export default Exam;